import React, { forwardRef, useEffect, useState } from 'react'
import {Form, Input, Select, DatePicker} from 'antd'
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

const UpdateUserForm = forwardRef((props,ref) => {
  const {groupPermission} = props//接收父組建的list清單，用於顯示下拉式表單
  const [defaultGroupPermissionId, setDefaultGroupPermissionId] = useState(2)
  const nameToEmail = ()=> {
    let emailPrefix = '@example.net'
    let originalFormValue = ref.current.getFieldsValue()
    ref.current.setFieldsValue(
      {...originalFormValue, ...{email:originalFormValue.name + emailPrefix}}
    )
  }
  useEffect(()=>{
    let defaultGroupPermission = groupPermission.find(item=>item.default === 1);
    setDefaultGroupPermissionId(defaultGroupPermission.id)
  },[groupPermission])

    return (
      <Form
          layout="vertical"
          ref={ref}
      >
        <Form.Item
          name="employee_id"
          label="員工編號"
        >
          <Input/>
        </Form.Item>
        <Form.Item
          name="chinese_name"
          label="中文姓名"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="name"
          label="英文姓名(登入帳號)"
          rules={[{required: true,message: '請輸入員工英文名字'}]}
        >
          <Input onChange={nameToEmail}/>
        </Form.Item>
        <Form.Item
          name="email"
          label="電子郵件"
          rules={[{required: true,message: '請輸入電子郵件'}]}
        >
          <Input/>
        </Form.Item>
        <Form.Item
          name="password"
          label="密碼(填入新密碼以進行更改，無需更改請留空)"
          rules={[{
            required: false,
            message: '密碼必須5個字元(含)以上',
            min: 5,
          }]}
        >
          <Input.Password
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item
          name="group_permission_id"
          label="請選擇群組權限"
          initialValue={defaultGroupPermissionId}
          rules={[{required: true,message: '請選擇群組權限'}]}
        >
          <Select
              showSearch
              style={{ width: '100%' }}
              fieldNames={{ label: 'name',value: 'id' }}
              options={groupPermission}
              filterOption={(input, option) =>{
                return (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
              }}
          />
        </Form.Item>
        <Form.Item
          name="dateOfEmployment"
          label="到職日期"
          rules={[{required: true,message: '請輸入到職日期'}]}
        >
          <DatePicker
            style={{ width: '100%' }}
            format={'YYYY/MM/DD'}
          />
        </Form.Item>
        <Form.Item
          name="dateOfResignation"
          label="離職日期(填入後將關閉帳號)"
        >
          <DatePicker
            style={{ width: '100%' }}
            format={'YYYY/MM/DD'}
          />
        </Form.Item>
      </Form>
    )
})
export default UpdateUserForm
